module.exports = __webpack_public_path__ + "img/Rectangle76.c64def7d.png";